import { geoTypeLabel } from '@/Enums/Geography/GeographyType.enum';
import { GREY, PRIMARY } from '@/constants/color';
import Clear from '@mui/icons-material/Clear';
import { IconButton, Popover } from '@mui/material';
import PropTypes from 'prop-types';
import { memo, useCallback, useState } from 'react';

const RestLocationsChip = memo(({ numberOfHiddenLocations, hiddenLocations = [], onRemove, isNotFound }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  return (
    <>
      <div
        className={`flex px-3 py-1 border border-[${
          isNotFound ? '#F95738' : '#DADADA'
        }] rounded-full cursor-pointer hover:border-[#1B4332] hover:bg-[#1b43320a]`}
        onClick={handleClick}
      >
        <span className={`text-[${isNotFound ? '#F95738' : PRIMARY}] text-[14px] font-semibold`}>
          +{numberOfHiddenLocations}
        </span>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <div style={{ maxHeight: 300, overflowY: 'auto', padding: '8px 0' }}>
          {hiddenLocations.map(({ id, displayName, type }) => (
            <div key={id} className='flex items-center justify-between gap-2 px-3 py-1 min-w-[200px]'>
              <div className='flex items-center gap-2'>
                <span className={`text-[${PRIMARY}] text-[14px] font-semibold`}>{displayName}</span>
                <span className={`text-[${GREY}] text-[12px]`}>{geoTypeLabel(type)}</span>
              </div>
              {onRemove && (
                <IconButton sx={{ fill: GREY, padding: 0 }} onClick={onRemove(id)}>
                  <Clear sx={{ width: '16px', height: '16px' }} />
                </IconButton>
              )}
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
});

RestLocationsChip.propTypes = {
  numberOfHiddenLocations: PropTypes.number,
  hiddenLocations: PropTypes.arrayOf(PropTypes.object),
  onRemove: PropTypes.func,
  isNotFound: PropTypes.bool,
};

export default RestLocationsChip;
